/* eslint-disable no-underscore-dangle */
/* eslint-disable comma-dangle */
/* eslint-disable object-curly-newline */
import { useTranslate } from 'hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';

import { setModal } from 'modules/_shared/redux/modalActions';
import DocumentModal from 'modules/documents/pages/Documents/documentModal';
import { useGetInvestorDocuments } from 'modules/partners/hooks/useGetInvestorDocuments';
import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';

import PartnerDocumentsRow from './PartnerDocumentsRow';

const InvestorDocuments = ({ society, investor }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { user, isAdmin } = useSelector((state) => ({
    user: state.user,
    isAdmin: state.society?.role?.isAdmin,
  }));

  const { documents } = useGetInvestorDocuments({
    investorId: investor['_id'],
  }).data;

  const { isReadOnly } = useGetPartnersSectionPermissions().data;

  const fullName = investor.name || '';

  const rows = documents.map((document, index) => (
    <PartnerDocumentsRow
      document={document}
      index={index + 1}
      key={document?.['_id']}
    />
  ));

  return (
    <div className="card-inner card-inner-lg">
      <div className="nk-block-head">
        <div className="nk-block-between g-3">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{t('Documents')}</h4>
            <div className="nk-block-des">
              <p>
                {t('InvestorDocumentationPar', {
                  investorName: fullName,
                  societyName: society.name,
                })}
              </p>
            </div>
          </div>

          <div className="nk-block-head-content">
            {isAdmin && (
              <div className="nk-block float-right">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    dispatch(
                      setModal(
                        <DocumentModal
                          userId={user['_id']}
                          societyId={society['_id']}
                          investorId={investor['_id']}
                        />
                      )
                    )
                  }
                  disabled={isReadOnly}
                >
                  <em className="icon ni ni-upload mr-1" />
                  {t('UpDocument')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {rows.length ? (
        <div className="nk-block nk-block-lg">
          <div className="card card-bordered card-preview">
            <table className="nk-tb-list nk-tb-ulist">
              <thead>
                <tr className="nk-tb-item nk-tb-head">
                  <th className="nk-tb-col" scope="col">
                    {t('No')}
                  </th>
                  <th className="nk-tb-col" scope="col">
                    {t('Name')}
                  </th>
                  <th className="nk-tb-col" scope="col">
                    {t('Date')}
                  </th>
                  <th className="nk-tb-col" scope="col">
                    {t('Doc')}
                  </th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default InvestorDocuments;
